import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { UserPreferences } from './types';
import { RootState } from '../types';

export const state: UserPreferences = {
  currency: 'EUR',
  country: '',
  locale: 'en-US',
};

const namespaced = true;

export const preferences: Module<UserPreferences, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
};
